import { render, staticRenderFns } from "./faltantes_expedientes.vue?vue&type=template&id=65e28dc2"
import script from "./faltantes_expedientes.vue?vue&type=script&lang=js"
export * from "./faltantes_expedientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports